import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

function ConfirmationReactivateMachineModal({ show, handleCancel, handleSubmit, selectedUtgsSignal }) {
    return (
        <Modal show={show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Reactivate Selected Machines</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to reactivate the {selectedUtgsSignal.value.length} selected machine(s)?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button variant="primary" onClick={handleSubmit}>Reactivate</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmationReactivateMachineModal
